<template>
  <div class="product-detail-floor-3-container">
    <div class="product-detail-floor-3-content">
      <div id="floor3" class="product-detail-floor-3-right">
        <el-tabs type="border-card" v-model="activeIndex">
          <el-tab-pane label="商品介绍" name="first">
            <div class="product-detail-floor-3-column">
              <el-row>
                <el-col
                  :key="index"
                  :span="8"
                  class="product-detail-attr"
                  v-for="(item, index) in productDetail.attributes"
                >
                  {{ item.attributeName }}:{{ item.attributeValue }}
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="product-detail-attr">
                  <el-tooltip
                    placement="top"
                    :content="productDetail.remark"
                    effect="dark"
                    :disabled="disabled"
                  >
                    <div
                      @mouseenter="showToolTips(productDetail.remark)"
                      @mouseleave="hideToolTips"
                      class="ellipsis"
                      slot="reference"
                    >
                      备注:{{ productDetail.remark }}
                    </div>
                  </el-tooltip>
                  <!--                      <el-tooltip effect="dark" :content="productDetail.remark" placement="top-start">-->
                  <div v-if="!disabled" class="ellipsis">备注:{{ productDetail.remark }}</div>
                  <!--                      </el-tooltip>-->
                </el-col>
              </el-row>
            </div>
            <div class="product-detail-floor-3-img" v-if="productDetail.systemSign == 2">
              <div
                v-if="productDetail.detailImageUrls.length"
                v-html="getPartStr(productDetail.detailImageUrls[0])"
              ></div>
            </div>
            <div class="product-detail-floor-3-img" v-else>
              <img
                :src="item"
                v-for="(item, index) in productDetail.detailImageUrls"
                :key="index"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane label="附件" name="third">
            <div class="product-detail-floor-3-attach">
              <div class="product-detail-floor-rate-list">
                <el-table :data="productDetail.skuFiles" border>
                  <el-table-column prop="fileName" label="附件名称" align="center">
                    <template slot-scope="scope">
                      {{ scope.row.fileName }}
                    </template>
                  </el-table-column>
                  <el-table-column label="下载" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="handleDownload(scope.row.fileUrl)">
                        下载
                      </el-button>
                    </template>
                  </el-table-column>
                  <template slot="empty">
                    <div
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        margin-top: 40px;
                      "
                    >
                      <div style="font-size: 14px; color: #666666">
                        暂无数据
                      </div>
                    </div>
                  </template>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!--          </div>-->
      </div>
    </div>
  </div>
</template>

<script>
//import RateList from '../../../components/product/productDetail/rateList';
export default {
  name: 'product-detail-floor-3',
  components: {
    //RateList,
  },
  props: {
    productDetail: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      activeIndex: 'first',
      rateList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 5,
      },
      listFilterData: {
        total: 0,
      },
      goodRate: '',
      badRate: '',
      dataList: [],
      disabled: false,
      isUrl: true,
    };
  },
  computed: {},
  created() {},
  methods: {
    //翻页
    handleCurrentChange(page) {
      this.queryParams.pageNum = page;
      // this.getRateList();
    },
    formatDimensions(val) {
      let res = '';
      switch (val) {
        case 101:
          res = '质量';
          break;
        case 102:
          res = '性价比';
          break;
        case 103:
          res = '交货';
          break;
        case 104:
          res = '服务';
          break;
      }
      return res;
    },
    handleDownload(url) {
      window.location.href = url;
    },
    //活得好评率和差评率
    async getGoodRate() {
      let params = {
        productSkuId: this.productDetail.skuId,
      };
      let res = await this.$request.getRate(params);
      if (res.code == '200') {
        this.goodRate = res.data.goodPercent;
        this.badRate = res.data.badPercent;
      }
    },
    showToolTips(item1) {
      if (validateStrLen(item1) > 183) {
        this.disabled = false;
      }
    },
    hideToolTips() {
      this.disabled = true;
    },
    getPartStr(str) {
      let startInx = str.indexOf('<body>');
      let endInx = str.indexOf('</body>');
      let matchStr = '';
      if (startInx != -1) {
        matchStr = str.slice(startInx + 6, endInx);
      } else {
        matchStr = str;
      }
      return matchStr;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme.scss';
.product-detail-floor-3-container {
  width: 100%;
  margin-top: 30px;
  margin-bottom: 80px;
  .product-detail-floor-3-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    /*justify-content: flex-start;*/
    .product-detail-floor-3-left {
      width: 20%;
      /*display: flex;*/
      /*justify-content: center;*/
      /*align-items: center;*/
      /*flex-direction: column;*/
      .product-detail-floor-3-title {
        width: 220px;
        height: 40px;
        background: #bddbff;
        font-weight: bold;
        line-height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: #333333;
        ::v-deep .el-tabs__item.is-active {
          color: $main-col;
        }

        .el-tabs__active-bar {
          background-color: $main-col;
        }
      }
      .product-detail-floor-3-list {
        padding-bottom: 10px;
        padding-top: 10px;
        padding-left: 8px;
        min-height: 500px;
        width: 220px;
        background: #ffffff;
        border-left: 1px solid #e2e2e2;
        border-right: 1px solid #e2e2e2;
        border-bottom: 1px solid #e2e2e2;
      }
    }
    .product-detail-floor-3-right {
      width: 100%;
      height: auto;
      ::v-deep .el-tabs--border-card {
        box-shadow: none;
        height: auto;
        border-right: 1px solid #d9d9d9;
        border-left: 1px solid #d9d9d9;
        border-top: 1px solid #d9d9d9;
      }
      ::v-deep.el-tabs--border-card > .el-tabs__header {
        background-color: #f5f5f5;
        border-bottom: 1px solid #d9d9d9;
      }
      ::v-deep .el-tabs__nav-scroll {
      }
      ::v-deep.el-tabs__item.is-active {
        border-right-color: transparent;
        border-left-color: transparent;
        border-top: 3px solid #2587ff;
        height: 43px;
      }

      ::v-deep.el-tabs__active-bar {
      }
      ::v-deep.el-tabs__item {
        transition: none;
        &:hover {
          color: $main-col;
        }
      }
      .product-detail-floor-3-column {
        margin-left: 40px;
        margin-top: 30px;
        .product-detail-attr {
          font-size: 14px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 10px;
        }
      }
      .product-detail-floor-3-rate {
        margin-top: 20px;
        .product-detail-floor-rate {
          margin-top: 20px;
          font-size: 26px;
          font-weight: 400;
          color: #666666;
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-direction: row;
          .good-rate {
            .product-detail-floor-rate-img {
              width: 30px;
              height: 30px;
              margin-right: 10px;
            }
          }
          .bad-rate {
            margin-right: 60px;
            .product-detail-floor-rate-img {
              width: 30px;
              height: 30px;
              margin-right: 10px;
            }
          }
        }
        .product-detail-floor-rate-list {
          margin-top: 40px;
          .rate-star {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .rate-buy-info {
              font-size: 14px;
              font-weight: 400;
              color: #333333;
            }
            .rate-time {
              font-size: 12px;
              font-weight: 400;
              color: #999999;
            }
            .rate-dimensions {
              width: 100%;
              display: flex;
              justify-content: center;
              .rate-dimensions-txt {
                width: 60px;
                display: flex;
                justify-content: flex-end;
              }
            }
          }
          ::v-deep .el-table th {
            width: 970px;
            height: 30px;
            background: #f7f7f7;
            border: 1px solid #f2f2f2;
            padding: 0 0;
          }
        }
        .product-detail-floor-pagination {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .product-detail-floor-3-img {
        margin-top: 20px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
    }
  }
}
</style>
